import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/core/models/api-response';
import { IOrderTypeResponse, IOrderTypeRequest } from '../models/order-type.model';

@Injectable({
  providedIn: 'root',
})
export class OrderTypeApiService {
  headers = { 'content-type': 'application/json' };

  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/orderTypes`;
  }

  constructor(private http: HttpClient) {}

  getPagedOrderTypes(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IOrderTypeResponse[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IOrderTypeResponse[]>>(this.url, { params });
  }

  getAllOrderTypes(departmentId?: string): Observable<IOrderTypeResponse[]> {
    let url = `${this.url}/List`;
    if (departmentId) {
      url = `${url}?DepartmentId=${departmentId}`;
    }
    return this.http.get<IOrderTypeResponse[]>(url);
  }

  getOrderTypeById(id: string): Observable<IOrderTypeResponse> {
    const url = `${this.url}/${id}`;
    return this.http.get<IOrderTypeResponse>(url);
  }

  createOrderType(orderType: IOrderTypeRequest): Observable<IOrderTypeResponse> {
    return this.http.post<IOrderTypeResponse>(this.url, orderType, { headers: this.headers });
  }

  updateOrderType(orderType: IOrderTypeRequest): Observable<IOrderTypeResponse> {
    const url = `${this.url}/${orderType.id}`;
    return this.http.put<IOrderTypeResponse>(url, orderType, { headers: this.headers });
  }

  deleteOrderType(id: string) {
    const url = `${this.url}/${id}`;
    return this.http.delete<IOrderTypeResponse>(url);
  }
}
